// extracted by mini-css-extract-plugin
module.exports = {"searchIcon":"Search_searchIcon__1shpe","left":"Search_left__1dYJ4","rotate":"Search_rotate__2SRjk"};